'use strict';

var files = [];
var $phoneInput = $('#phone');
var urls = [];
var caseNumber = "";
var $textarea = $('#solicitud');
/**
 * Actualizar la lista de archivos
 */
function updateFileList() {
    var fileListContainer = $('#fileList');
    fileListContainer.empty(); 

    var fileNames = files.map(function(file) {
        return file.name;
    }).join(', ');

    fileListContainer.text(fileNames);

    if (files.length > 0) {
        $('#clearAllFiles').show();
        $('.file-types-text').hide();
    } else {
        $('#clearAllFiles').hide();
        $('.file-types-text').show();
    }
}

/**
 * @returns {boolean} True or false
 */
function validatePhoneInput() {
    var isValid = true;
    var $errorElement = $('#' + $phoneInput.attr('aria-describedby'));

    if ($phoneInput.val().length < $phoneInput.attr('minlength')) {
        $errorElement.text($phoneInput.data('too-short-error'));
        $phoneInput.addClass('is-invalid');
        isValid = false;
    } else {
        $phoneInput.removeClass('is-invalid');
        $errorElement.text('');
    }

    return isValid;
}

/**
 * Eliminar archivos
 */
function clearAllFiles() {
    files = [];
    updateFileList();
    $('#fileInput').val('');
}

$(document).ready(function () {
    var maxLength = $textarea.attr('maxlength');
    var $errorElement = $('#form-solicitud-error');

    $textarea.on('input', function () {
        var textareaLength = $textarea.val().length;
        if (textareaLength >= maxLength) {
            $errorElement.text($textarea.data('too-solicitud-error')).show();
        } else {
            $errorElement.text('').hide();
        }
    });

    var urlParams = new URLSearchParams(window.location.search);
    var caseNumberUrl = urlParams.get('caseNumber');
    
    if (caseNumberUrl) {
        $('#caseNumber').text(caseNumberUrl);
    }

    if (window.innerWidth <= 544) {
        $('.sub-title-landing br').remove();
    }
    
    $(document).on('click', function (event) {
        if (!$(event.target).closest('.contact-us-option').length) {
            $('.contact-us-option').removeClass('hover');
        }
    });

    $(document).on('click', '.chatbot', function () {
       
        var isChatBot = $('input[name="isEnableChatContact"]').val();
        var chatIframe = $('iframe[title="Sesión de chat con un agente"]');
        var contactOption = $('.contact-us-option');
    
        if (isChatBot) {
            $('#embeddedMessagingConversationButton').trigger('click');

            if (chatIframe.length > 0) {
                contactOption.addClass('hover');
            } else {
                contactOption.removeClass('hover');
            }
        }
        
    });


    $('#categories').on('change', function () {
        var $formContact = $('#uploadForm');
        var selectedOption = $(this).find('option:selected');
        var selectedOptGroup = selectedOption.closest('optgroup');
        var selectedGroup = selectedOptGroup.data('group');
        var selectedGroup2 = selectedOption[0].innerText;
        $('#selectedCategory').val(selectedGroup);

        if (selectedGroup == "Garantías") {
            $formContact.find('.general-form-fields').hide();
            $formContact.find('.warranty-form-fields').removeClass('d-none');
            $formContact.find('.warranty-form-fields input[name="ticket"]').attr('required', 'required');
            $formContact.find('.warranty-form-fields select[name="selectedSubcategory"]').attr('required', 'required');
            $(this).val('');
            $(this).removeAttr('required');
            $('.warranty-content').removeClass('d-none');
            $('#categories-warranty').val(selectedGroup2);
            $('h1.text-center.mb-4').text('Garantías');
        }
    });

    $('#categories-warranty').on('change', function () {
        var $formContact = $('#uploadForm');
        var selectedOption = $(this).find('option:selected');
        var selectedOptGroup = selectedOption.closest('optgroup');
        var selectedGroup = selectedOptGroup.data('group');
        $('#selectedCategory').val(selectedGroup);

        if (selectedGroup != "Garantías") {
            $formContact.find('.general-form-fields').show();
            $formContact.find('.warranty-form-fields').addClass('d-none');
            $formContact.find('.warranty-form-fields input[name="ticket"]').removeAttr('required');
            $formContact.find('.general-form-fields select[name="selectedSubcategory"]').attr('required', 'required');
            $(this).val('');
            $(this).removeAttr('required');
        }
    });

    $('#solicitud').on('input', function () {
        if ($(this).val()) {
            $(this).removeClass('is-invalid');
        }
    });
    
    /** Inicio de funcionalidad de la carga de archivos */

    $('#dropZone').on('dragover', function (event) {
        event.preventDefault();
        event.stopPropagation();
        $(this).css('border-color', '#000');
    });
    
    $('#dropZone').on('dragleave', function (event) {
        event.preventDefault();
        event.stopPropagation();
        $(this).css('border-color', '#ccc');
    });
    
    $('#dropZone').on('drop', function (event) {
        event.preventDefault();
        event.stopPropagation();
        $(this).css('border-color', '#ccc');
    
        var droppedFiles = event.originalEvent.dataTransfer.files;
        for (var i = 0; i < droppedFiles.length; i++) {
            files.push(droppedFiles[i]);
        }

        updateFileList();
    });
    
    $('#dropZone').on('click', function () {
        $('#fileInput').click();
    });
    

    $('#fileInput').on('change', function (event) {
        var selectedFiles = event.target.files;
        for (var i = 0; i < selectedFiles.length; i++) {
            files.push(selectedFiles[i]);
        }
        
        updateFileList();
    });    
    
    $('#clearAllFiles').on('click', function () {
        clearAllFiles();
    });
    
    /** Fin de funcionalidad de la carga de archivos */

    $('form#uploadForm').submit(function (event) {
        event.preventDefault(); 
        var $form = $(this);
        var submitButton = $form.find('button[type="submit"]');
        submitButton.prop('disabled', true);
        var $questionsFormContent = $form.closest('.questions-form-content');
        var $contactUsMsg = $questionsFormContent.siblings('.contact-us-msg');

        var isValid = validatePhoneInput();

        if (!isValid) {
            event.preventDefault()
            submitButton.prop('disabled', false);
            return;
        }

        if (!$textarea.val()) {
            $textarea.addClass('is-invalid');
            submitButton.prop('disabled', false);
            return;
        }

        var formData = new FormData(this); 

        for (var i = 0; i < files.length; i++) {
            formData.append('files[]', files[i]); 
        }
        if(caseNumber != "" && urls != "") {
            formData.append('isUpdateCase', true);
            formData.append('caseNumber', caseNumber); 
            formData.append('urls', JSON.stringify(urls)); 
        }

        if (files.length > 0) {
            $("#fileUpload-modal").modal('show');
        }
        $.ajax({
            url: $form.attr('action'),
            type: $form.attr('method'),
            data: formData,
            processData: false,
            contentType: false,
            success: function(response) {
                if(response.error && response.serviceFiles) {
                    submitButton.prop('disabled', false);
                    response.filesError.forEach(function(errorFile) {
                        var fileNameToRemove = errorFile.file;
            
                        // Filtrar los archivos para eliminar el que coincide con el nombre
                        files = files.filter(function(file) {
                            return file.name !== fileNameToRemove;
                        });
                    });
            
                    // Actualizar la lista de archivos en el frontend
                    updateFileList();
            
                    if (files.length > 0) {
                        $("#fileUpload-modal").modal('hide');
                        $("#fileUploadError-modal").modal('show');
                    }
                    urls = response.urls;
                    caseNumber = response.caseNumber;
                } else {
                    $questionsFormContent.addClass('d-none');
                    $contactUsMsg.removeClass('d-none');
                    $('#caseNumber').text(response.caseNumber);
                    if (files.length > 0) {
                        $("#fileUpload-modal").modal('hide');
                    }
                }
            },
            error: function(jqXHR, textStatus, errorThrown) {
                submitButton.prop('disabled', false);
                $("#fileUpload-modal").modal('hide');
                $("#fileUploadError-modal").modal('show');
            }
        });
    });

});

